/* eslint-disable no-unused-vars */
/* global G */

/**
 * Replaces the local cart data on the adapter with the provided detail (when present)
 * and dispatches `G.CART, G.DONE`.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => async ({ detail = {} }) => {
  const adapter = app[G.ADAPTER][G.CART]
  const eventBus = app[G.ADAPTER][G.EVENTS]

  const { [G.DATA]: providedCart = null } = detail || {}

  if (providedCart) {
    adapter[G.DATA] = providedCart
  }

  eventBus.dispatch(eventBus.type(G.CART, G.DONE), { [G.DATA]: adapter[G.DATA] })
}

export default fn
